import React, { memo, useLayoutEffect, useRef, useState } from "react";
import { propertyListingHelperForResponsive } from "../../Utils/propertyListingHelperForResponsive";
import { Box } from "@mui/material";
import { EastOutlined, WestOutlined } from "@mui/icons-material";
import Slider from "react-slick";

/**
 * Added fade overlays on left and right edges to create blur effect
 * Mistakes corrected: moved backdropFilter to overlay boxes and added CSS gradient mask
 */
const _fadeWidth = 100; // width of blur overlay in px

type PropertySliderProps = {
  children?: any;
  setting?: any;
};

const PropertySlider = memo((props: PropertySliderProps) => {
  const [sliderIndex, setSliderIndex] = useState(0);
  const [, setInnerWidth] = useState(window.innerWidth);
  const sliderRef = useRef<any>(null);

  useLayoutEffect(() => {
    function updateWidth() {
      setInnerWidth(window.innerWidth);
    }
    window.addEventListener("resize", updateWidth);
    updateWidth();
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  // const _devi = propertyListingHelperForResponsive();
  const { display: slidesToShow = 1 } = propertyListingHelperForResponsive() ?? {};
// const _devi = propertyListingHelperForResponsive() || {};
// const slidesToShow = (_devi.display ?? 1); 
  const settings = {
    infinite: false,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    swipeToSlide: true,
    afterChange: (current: any) => setSliderIndex(current),
    ...props.setting,
  };

  const slideRight = () => sliderRef.current?.slickNext();
  const slideLeft = () => sliderRef.current?.slickPrev();

  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      {/* Slider */}
      <Slider ref={sliderRef} {...settings} arrows={false}>
        {props.children}
      </Slider>

      {/* Right blur overlay */}
      {sliderIndex < (props.children?.length - slidesToShow) && (
        <Box
          sx={{
            display: { xs: 'none', sm: 'block' },
            pointerEvents: 'none',
            position: 'absolute',
            right: 0,
            top: 0,
            width: _fadeWidth,
            height: '100%',
            background: 'linear-gradient(to left, rgba(255,255,255,0.7), rgba(255,255,255,0))',
          }}
        />
      )}

      {/* Left blur overlay */}
      {sliderIndex > 0 && (
        <Box
          sx={{
            display: { xs: 'none', sm: 'block' },
            pointerEvents: 'none',
            position: 'absolute',
            left: 0,
            top: 0,
            width: _fadeWidth,
            height: '100%',
            background: 'linear-gradient(to right, rgba(255,255,255,0.7), rgba(255,255,255,0))',
          }}
        />
      )}

      {/* Right arrow button */}
      {sliderIndex < (props.children?.length - (slidesToShow ?? 1)) && (
        <Box
          sx={{
            position: 'absolute',
            right: 10,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1,
          }}
        >
          <Box
            onClick={slideRight}
            sx={{
              p: {
                xs:3,
                md:4,
                lg:6
              },
              borderRadius: '50%',
              bgcolor: 'white',
              cursor: 'pointer',
              boxShadow:'rgba(0, 0, 0, 0.35) 0px 5px 15px',
              display:'flex'
            }}
          >
            <EastOutlined 
              sx={{
                fontSize:{
                  xs:'1.5rem',
                  lg:'2rem'
                }
              }}
            />
          </Box>
        </Box>
      )}

      {/* Left arrow button */}
      {sliderIndex > 0 && (
        <Box
          sx={{
            position: 'absolute',
            left: 10,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1,
          }}
        >
          <Box
            onClick={slideLeft}
            sx={{
              p: {
                xs:3,
                md:4,
                lg:6
              },
              borderRadius: '50%',
              bgcolor: 'white',
              cursor: 'pointer',
              boxShadow:'rgba(0, 0, 0, 0.35) 0px 5px 15px',
              display:'flex'
            }}
          >
            <WestOutlined 
              sx={{
                fontSize:{
                  xs:'1.5rem',
                  lg:'2rem'
                }
              }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
});

export default PropertySlider;
